import React from "react"
import ProductSlider from "./ProductSlider";

const CatalogCard = ({content}) => {
  return (
    <div className="catalog-card">
      <h3 className="catalog-card-title">
        {content.title}
      </h3>
      { content.items.length === 0 ? 
        <p className="catalog-card-empty">Sem produtos destacados</p>
      :
        <ProductSlider 
          backgroundColor={content.background_color} 
          borderColor={content.border_color}
          textColor={content.text_color}
          products={content.items}
        />
      }
      

    </div>
  )
}

export default CatalogCard
